@if (dataModal) {
  <div class="modal-with-two-buttons-container">
    <h2>{{ dataModal?.texts?.title }}</h2>
    <p [innerHTML]="dataModal?.texts?.content"></p>

    <div class="container-buttons">
      <ds-button class="button-back" [text]="'buttons.close' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="onBack()"></ds-button>
      @if (dataModal?.texts.first_button_pointer) {
        <ds-button
          class="button-action"
          [text]="'buttons.' + [dataModal?.texts.first_button_pointer] | translate | uppercase"
          [width]="'small'"
          (click)="onAction()"
          [styleType]="dataModal?.colorActionButton === 'red' ? 'default-accent' : 'default-main'"
        ></ds-button>
      }
    </div>
  </div>
}
